import us from './defines';

/*
 This file is **outdated** and will be replaced. It contains switches for disabling of features.

 THE PREFERRED APPROACH IS TO SIMPLY INCLUDE OR EXCLUDE THE CODE FOR THE FEATURE.

 The following switches can be overridden by uScopeStart's settings ...................
 */

us.ENABLELABEL = true; // default true, enable load/create of the label
us.ENABLEMAG = true; // default true, enable load/create of the magnifier
us.ENABLETHUMB = true; // default true, enable load/create of the thumbnail
us.ENABLESCALEBAR = true; // default true, enable load/create of the scale bar
us.ENABLEZOOMCTL = true; // default true, enable load/create of the zoom control
us.ENABLEZOOMSLIDER = true; // default true, enable load/create of the zoom slider control
us.ENABLEROTATION = true; // default true, enable image rotation
us.ENABLEHEATMAP = true; // default true, visibility and draw switch
us.ENABLEAUTOANNOTSAVE = true; // default true, enable automatic (as drawn) save annotations
us.ENABLEANNOTCREATE = true; // default true, [dis|en]able annotation creation
us.ENABLEANNOTSELSAVE = false; // default false, enable save each region select action - NOT overridden (yet) by start settings
us.ENABLELINKTOIMAGE = false; // default false, provide link to image
us.SHOWALLTOOLBARICONS = false; // default false, display all top toolbar icons
us.DISABLEUSERPREFS2DB = false; // default false, inhibit read/write to database
us.ENABLETHUMBHOVER = true; // default true, allows hover over thumbnail to enlarge thumbnail



// WEBPACK FOOTER //
// ./src/uScope/js/switches.js